import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/tips', request)
}

export {get}
